<template>
  <accordion-item-fi
    v-if="hasTextList"
    class="accordion-learning-targets-fi"
    header-tag="h3"
    ignore-others
    scroll-to
  >
    <template #header>
      {{ $dict.get('product-Catalog.Accordions.Learning-Targets') }}
    </template>
    <template #content>
      <div class="accordion-learning-targets-fi__content">
        <div class="accordion-learning-targets-fi__column">
          <richtext-fi
            class="accordion-learning-targets-fi__text"
            :html-content="{ value: hasTextList }"
          />
        </div>
      </div>
    </template>
  </accordion-item-fi>
</template>

<script setup lang="ts">
import { AccordionItemFi, RichtextFi } from 'atoms';
import { computed } from 'vue';

import { useBreakpoints } from '@/composables/breakpoint';
import { useCatalogTextList } from '@/composables/catalogTextList';

defineOptions({ name: 'AccordionLearningTargetsFi' });

interface TextListItem {
  Key?: string;
  AttributeKey?: string;
  Value?: string;
}

interface Props {
  catalogData?: {
    TextList?: TextListItem[];
  };
}

const props = withDefaults(defineProps<Props>(), {
  catalogData: () => ({}),
});

useBreakpoints();

const { textListValue } = useCatalogTextList();

const textList = computed(() => props.catalogData?.TextList);
const hasTextList = computed(() => textListValue(textList.value, 'LEARNING_OBJECTIVE'));
</script>

<style src="./accordion-learning-targets-fi" />
